import { render, staticRenderFns } from "./VMentionedUsers.vue?vue&type=template&id=1d012966&scoped=true"
import script from "./VMentionedUsers.vue?vue&type=script&lang=ts"
export * from "./VMentionedUsers.vue?vue&type=script&lang=ts"
import style0 from "./VMentionedUsers.vue?vue&type=style&index=0&id=1d012966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d012966",
  null
  
)

export default component.exports